import api from '../api';
import { 
  BoardInvite, 
  CreateBoardInvite, 
  AcceptBoardInvite, 
  BoardUser, 
  UpdateBoardUserAccess 
} from '../../interfaces/boardInvite';

const boardInviteService = {
  // Create a new board invite
  async createInvite(boardId: string, data: CreateBoardInvite): Promise<BoardInvite> {
    const response = await api.post(`/boards/${boardId}/invites`, data);
    return response.data.data;
  },

  // Get all invites for a board
  async getBoardInvites(boardId: string): Promise<BoardInvite[]> {
    const response = await api.get(`/boards/${boardId}/invites`);
    return response.data.data;
  },

  // Delete a board invite
  async deleteInvite(boardId: string, inviteId: string): Promise<void> {
    await api.delete(`/boards/${boardId}/invites/${inviteId}`);
  },

  // Get all users with direct access to a board
  async getBoardUsers(boardId: string): Promise<BoardUser[]> {
    const response = await api.get(`/boards/${boardId}/invites/users`);
    return response.data.data;
  },

  // Update a board user's access level
  async updateBoardUserAccess(boardId: string, userId: string, data: UpdateBoardUserAccess): Promise<BoardUser> {
    const response = await api.put(`/boards/${boardId}/invites/users/${userId}`, data);
    return response.data.data;
  },

  // Remove a user from board
  async removeBoardUser(boardId: string, userId: string): Promise<void> {
    await api.delete(`/boards/${boardId}/invites/users/${userId}`);
  },

  // Get invite details by code
  async getInviteByCode(inviteCode: string): Promise<BoardInvite> {
    const response = await api.get(`/board-invites/${inviteCode}`);
    return response.data.data;
  },

  // Accept a board invite
  async acceptInvite(data: AcceptBoardInvite): Promise<BoardUser> {
    const response = await api.post('/board-invites/accept', data);
    return response.data.data;
  },

  // Add user directly to board
  async addUserDirectlyToBoard(boardId: string, userId: string, accessLevel: string): Promise<BoardUser> {
    const response = await api.post(`/boards/${boardId}/invites/users`, {
      userId,
      accessLevel
    });
    return response.data.data;
  },
};

export default boardInviteService;
